import React from 'react';
import { bool, func, string } from 'prop-types';

import ImageSystemMaintenance from '@assets/Image/DayTrading/SystemMaintenance.svg';
import ImageAccountSuspended from '@assets/Image/DayTrading/AccountSuspended.svg';
import ImageForceSell from '@assets/Image/DayTrading/ForceSell.svg';

import { Container, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const ERROR_MAP = {
  EC0008988: {
    img: ImageSystemMaintenance,
    alt: 'maintenance',
    title: 'Sistem Dalam Pemeliharaan',
    text: 'Halaman transaksi saham Day Trading sedang dalam pemeliharaan. Coba bertransaksi dengan akun lain.',
  },
  EC0008985: {
    img: ImageAccountSuspended,
    alt: 'account-suspended',
    title: 'Akun Tidak Dapat Bertransaksi',
    text: 'Hubungi Customer Service untuk informasi lebih lanjut mengenai akun Day Trading kamu.',
  },
  EC0008984: {
    img: ImageForceSell,
    alt: 'trading-session-over',
    title: 'Waktu Day Trading Berakhir',
    text: 'Transaksi Day Trading tidak dapat dilakukan lagi hari ini.',
  },
  default: {
    img: ImageSystemMaintenance,
    alt: 'maintenance',
    title: 'Gagal',
    text: 'Kami mengalami kendala dalam memroses traksaksi. Hubungi Customer Service untuk info lebih lanjut.',
  },
};

const PopUpDtApiError = (props) => {
  const { errCode, show, onHide } = props;

  const { img, alt, title, text } = ERROR_MAP[errCode] || ERROR_MAP.default;

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide}>
      <img src={img} alt={alt} />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          {title}
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          {text}
        </Typography>
      </Container>
      <Button fluid variant="primary" size="lg" onClick={onHide}>
        Kembali
      </Button>
    </PopUpCenterV2>
  );
};

PopUpDtApiError.propTypes = {
  errCode: string,
  show: bool,
  onHide: func,
};

PopUpDtApiError.defaultProps = {
  errCode: '',
  show: false,
  onHide: () => {},
};

export default PopUpDtApiError;
